import styled from 'styled-components'

export const CenterContent = styled.div`
	text-align: center;
`
